<script lang="ts" setup>
import Section1 from '@/pages/membership/components/Section1.vue'
import Section2 from '@/pages/membership/components/Section2.vue'
import Section3 from '@/pages/membership/components/Section3.vue'
import Faq from '@/pages/membership/components/Faq.vue'
import { useGlobalStore } from '@/stores'
import useSeo from './seo'
import { useWindowScroll } from '@vueuse/core'

const { y } = useWindowScroll()
const globalStore = useGlobalStore()

watch(
  () => y.value,
  (v) => {
    globalStore.isWhite1 = v >= 88
    globalStore.isWhite = v < 88
    globalStore.isHeaderTransparent = v <= 88
  }
)
const section2Ref = ref(null)
const section3Ref = ref(null)
onMounted(() => {
  if (section2Ref.value) {
    setTimeout(() => {
      useImagesLoaded('.section2 img').then(() => {
        section2Ref.value.initAni()
      })
    }, 150)
  }

  if (section3Ref.value) {
    setTimeout(() => {
      useImagesLoaded('.section3__inner img').then(() => {
        section3Ref.value.initAni();
      })
    }, 300)
  }
})
useSeo()
</script>

<template>
  <section class="membership">
    <div class="membership__full">
      <Section1 />
    </div>
    <div class="membership__full membership__full-3">
      <Section3 ref="section3Ref" />
      <Faq />
    </div>
  </section>
</template>

<style lang="scss" scoped>
.membership {
  &__full {
    margin-left: toRem(-24);
    margin-right: toRem(-24);

    &-3 {
      position: relative;
      z-index: 1;
      // transform: translateY(-100vh);
    }
  }
}
</style>
